import { Action, OperationType } from '../../../dispatcher/Types';
import DashboardGrid from '../../../components/dashboard/DashboardGrid';

export const addTabItem: Action = [{
  specialData: {
    addItemComponent: DashboardGrid
  },
  type: OperationType.data
}, {
  moduleName: 'TabPanel',
  name: 'addTabItem',
  args: ['tabItemConfig', '{{addItemComponent}}']
}];

export const updateTabItem: Action = [{
  name: 'handleUpdateTabDetails',
  moduleName: 'TabPanel',
  args: ['tabDetails']
}];
